import { Box, Container, Grid, Typography } from "@mui/material";

const Footer = () => {
    return (
        <Box sx={{ mt: 3 }}>
            {/* Full-width blue background */}
            <Box sx={{ width: "100%", bgcolor: "#1976d2", color: "white", py: 4 }}>
                <Container maxWidth="lg">
                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                        {/* Logo Section */}
                        <Grid item xs={3} md={3} sx={{ textAlign: "center" }}>
                            <img src="http://govirtual.ph/wp-content/uploads/2025/03/brain_score.png" alt="Logo" style={{ width: 150, maxWidth: "100%" }} />
                            {/* <Typography variant="h6" fontWeight="bold">govirtual</Typography> */}
                        </Grid>

                        {/* Contact Info */}
                        <Grid item xs={9} md={6}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                • 5F, Phinma Plaza, 39 Plaza Drive, Rockwell Center, Makati City
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                • info@govirtual.ph
                            </Typography>
                            <Typography variant="body1">
                                • +639 772698409
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Full-Width Copyright Section */}
            <Box sx={{ color: "gray", textAlign: "center", mt: 1, width: "100%" }}>
                <Typography variant="caption" sx={{ lineHeight: "0.9", width: "100%" }}>
                    Copyright 2025 Go Virtual Technology Solutions and Innovations Inc. All Rights Reserved
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
